import { render, staticRenderFns } from "./ecosystem-finance-totals.vue?vue&type=template&id=bdba36b8&"
import script from "./ecosystem-finance-totals.ts?vue&type=script&lang=js&"
export * from "./ecosystem-finance-totals.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports